<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="primary" class="elevation-1 mmqList">
          <template slot="header">
            <div
              style="
                display: grid;
                grid-template-columns: 1fr auto;
                padding: 0px 10px 0px 0px;
              "
            >
              <h4
                class="title font-weight-light mb-2"
                v-text="'MM Query'"
                style="padding: 10px"
              />
            </div>
          </template>

          <v-data-table
            id="mmq_dataTable"
            :headers="headers"
            :items="items"
            :pagination="pagination"
            @update:pagination="paginate"
            :rows-per-page-items="[5, 10, 20]"
            :total-items="totalItems"
            :loading="loading"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            sort-icon="mdi-menu-down"
          >
            <v-progress-linear
              slot="progress"
              color="green"
              indeterminate
            ></v-progress-linear>

            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    header.align ? 'text-xs-' + header.align : 'text-xs-left',
                    pagination.descending ? 'desc' : 'asc',
                    header.sortable != false ? 'sortable' : '',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="
                    if (header.sortable != false) {
                      changeSort(header.value);
                    }
                  "
                >
                  <v-icon v-if="header.sortable != false" small
                    >mdi-menu-down</v-icon
                  >
                  <span
                    class="subheading font-weight-dark text-success text-darken-3"
                    v-text="header.text"
                  ></span>
                </th>
              </tr>

              <tr class="lighten-3">
                <th v-for="header in props.headers" :key="header.text">
                  <div
                    v-if="filters.hasOwnProperty(header.value)"
                    style="max-width: 200px"
                  >
                    <v-text-field
                      :style="filters[header.value].style + ' '"
                      clearable
                      v-if="filters[header.value].type == 'text'"
                      v-model="filters[header.value].value"
                      :placeholder="filters[header.value].placeholder"
                      @input="filterChanged(filters[header.value])"
                    />

                    <v-select
                      :style="filters[header.value].style + ' '"
                      clearable
                      v-if="filters[header.value].type == 'list'"
                      v-model="filters[header.value].value"
                      :items="filters[header.value].list"
                      :item-text="filters[header.value].item_text"
                      :item-value="filters[header.value].item_value"
                      :placeholder="filters[header.value].placeholder"
                      class="purple-input truncate"
                      @change="filterChanged(filters[header.value])"
                    ></v-select>

                    <v-autocomplete
                      :style="filters[header.value].style + ' '"
                      clearable
                      v-if="filters[header.value].type == 'autocomplete'"
                      v-model="filters[header.value].value"
                      :items="filters[header.value].list"
                      :item-value="filters[header.value].item_value"
                      :item-text="filters[header.value].item_text"
                      :placeholder="filters[header.value].placeholder"
                      class="purple-input"
                      @change="filterChanged(filters[header.value])"
                    ></v-autocomplete>

                    <safety-daterange
                      displayFormat="MM-dd"
                      :style="filters[header.value].style + ' '"
                      clearable
                      v-if="filters[header.value].type == 'daterange'"
                      v-model="filters[header.value].value"
                      :placeholder="filters[header.value].placeholder"
                      class="purple-input"
                      @input="filterChanged(filters[header.value])"
                    >
                    </safety-daterange>
                  </div>
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="{ item }">
              <tr>
                <td>{{ item.protocol_name }}</td>
                <td class="text-xs-left">
                  {{ item.cin || "-----" }}
                </td>

                <td class="text-xs-left">
                  <v-tooltip top min-width="500px">
                    <template slot="activator" slot-scope="{ on }">
                      <div v-on="on">
                        {{ item.site_code }}
                      </div>
                    </template>
                    <span
                      >{{ item.site_name }} - {{ item.site_city }} ({{
                        item.site_country_code
                      }}) - [{{
                        item.protocol_has_site_code
                          ? item.protocol_has_site_code
                          : "---"
                      }}]</span
                    >
                  </v-tooltip>
                </td>

                <td class="text-xs-left">
                  {{ item.patient_id }}
                </td>

                <td class="text-xs-left">
                  <v-tooltip
                    top
                    min-width="500px"
                    :disabled="item.ae_verbatim_reported.length <= 25"
                  >
                    <template slot="activator" slot-scope="{ on }">
                      <span v-on="on">
                        {{ item.ae_verbatim_reported | truncate(25, "...") }}
                      </span>
                    </template>
                    <span> {{ item.ae_verbatim_reported }}</span>
                  </v-tooltip>
                </td>

                <td class="text-xs-left">
                  {{ item.status }}
                </td>

                <td class="text-xs-right">
                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="upsertDialog(item)" class="ml-2">
                        <v-icon v-on="on" color="primary">mdi-eye</v-icon>
                      </a>
                    </template>
                    <span>View MM Query</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </material-card>

        <v-dialog max-width="1200px" v-model="uDialog">
          <safety-mm-query-upsert-modal :item="selectedItem" v-if="uDialog" />
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import { normalizeFilters } from "@/utils/filters";
import { getList } from "@/api/mm_query";

import { filters_store } from "./filters";
import { pagination_store } from "./pagination";

import moment from "moment";

export default {
  data() {
    return {
      loading: true,
      uDialog: false,
      items: [],
      totalItems: 0,

      selectedItem: {},

      headers: [
        { text: "Protocol", align: "left", value: "protocol_id" },
        { text: "Cin", align: "left", value: "adverse_event.cin" },
        { text: "Site", align: "left", value: "site.code", sortable: true },
        {
          text: "Patient",
          align: "left",
          value: "adverse_event.patient_id",
          sortable: true,
        },
        {
          text: "AE Verbatim Reported",
          align: "left",
          value: "adverse_event.ae_verbatim_reported",
          sortable: false,
        },

        { text: "Status", align: "left", value: "status", sortable: true },

        { text: "Actions", value: "actions", sortable: false, align: "right" },
      ],
      filters_store,
      pagination_store,
    };
  },
  computed: {
    filters() {
      this.filters_store["protocol.sponsor_id"] = {
        value: this.$store.getters.sponsor_id,
      };
      this.filters_store.protocol_id.list = this.$store.getters.protocols;
      return this.filters_store;
    },
    pagination() {
      return this.pagination_store.pagination_deep;
    },
  },

  created() {
    this.$store.dispatch("app/loadSponsors");
    this.$store.dispatch("app/sponsorsDisabled", false);

    this.$root.$on("sponsorChanged", (v) => {
      this.getData();
    });

    this.$root.$on("showClosedProtocolChanged", (v) => {
      this.getData();
    });
  },
  mounted() {
    this.getData();
  },
  destroyed() {
    this.$root.$off("sponsorChanged");
    this.$root.$off("showClosedProtocolChanged");
  },
  methods: {
    formatDate(x) {
      return moment(new Date(x)).format("DD-MMM-YYYY");
    },

    getData() {
      this.loading = true;

      let filters = normalizeFilters(JSON.parse(JSON.stringify(this.filters)));

      getList(filters, this.pagination).then((data) => {
        data.data.forEach(function (el) {
          el.expanded = false;
        });
        this.items = data.data;
        this.pagination.rowsPerPage = data.perPage;
        this.pagination.page = data.currentPage;
        this.pagination.totalItems = data.tot;
        this.totalItems = data.tot;
        this.loading = false;
      });
    },
    filterChanged() {
      const oldPagination = JSON.parse(
        JSON.stringify(this.pagination_store.pagination_deep),
      );
      oldPagination.page = 1;
      this.pagination_store.pagination_deep = oldPagination;
      this.getData();
    },
    paginate(v) {
      this.pagination_store.pagination_deep = v;
      this.getData();
    },
    sortAlias(col) {
      return this.pagination_store.alias[col] || col;
    },
    changeSort(column) {
      column = this.sortAlias(column);
      const oldPagination = JSON.parse(
        JSON.stringify(this.pagination_store.pagination_deep),
      );
      oldPagination.page = 1;
      if (oldPagination.sortBy === column) {
        oldPagination.descending = !oldPagination.descending;
      } else {
        oldPagination.sortBy = column;
        oldPagination.descending = true;
      }
      this.pagination_store.pagination_deep = oldPagination;
      this.getData();
    },
    upsertDialog(item = {}) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.uDialog = true;
    },
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      }
      return text;
    },
  },
};
</script>

<style lang="scss">
#mmq_dataTable {
  .v-datatable__actions {
    color: black;

    .v-btn__content {
      color: black;
    }

    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
    padding: 0px 5px 0px 5px;
  }

  .read td {
    font-size: 14px;
    font-weight: 300;
  }

  .unread td {
    font-weight: bold;
    background: #ffffff;
  }

  .canceled {
    text-decoration: line-through;
  }
}

.mmqList .v-card--material__header {
  padding: 0px 10px 0px 0px !important;
}
</style>
